import { useContext } from 'react'
import { ModalContext } from '../../../../contexts/modal-context'
import { ButtonConfig } from '../../../../types/andTypes'
import errorIcon from '../assets/error.svg'
import successIcon from '../assets/success.svg'
import Popup from '../popup'
import { ResultIcon } from '../popup-styles'

type ResultPopupProps = {
  children: JSX.Element
  success: boolean
  headerText: string
  actionButtonConfig?: ButtonConfig
}

const ResultPopup = ({ children, success, headerText, actionButtonConfig }: ResultPopupProps) => {
  const { setModalOpen } = useContext(ModalContext)

  const closeModal = () => {
    setModalOpen(false)
  }
  const buttonConfig: ButtonConfig[] = []
  actionButtonConfig && buttonConfig.push(actionButtonConfig)
  const resultHeader: string = success ? headerText : 'Oh no!'

  return (
    <Popup header={resultHeader} buttonConfig={buttonConfig} onPopupClose={closeModal}>
      <ResultIcon
        data-testid={`${success ? 'success-icon' : 'error-icon'}`}
        src={success ? successIcon : errorIcon}
        alt="error"
      />
      {children}
    </Popup>
  )
}

export default ResultPopup
